import { useAppState } from '@components/common/context/app';
import { get } from '@evershop/evershop/src/lib/util/get';

/**
 * Convenience hook for reading the current language from app context.
 * Use this instead of manually calling get(useAppState(), 'language', 'en') everywhere.
 *
 * @returns {{ language: string, isAr: boolean, isEn: boolean, dir: 'rtl'|'ltr' }}
 */
export function useLanguage() {
  const language = get(useAppState(), 'language', 'en');
  return {
    language,
    isAr: language === 'ar',
    isEn: language === 'en',
    dir: language === 'ar' ? 'rtl' : 'ltr'
  };
}
